import { useEffect } from 'react'

import { getScrollbarWidth } from 'Pods/Shared/Utils/getScrollbarWidth'

// Locks page scroll while the cart popover is open and pads the body by the
// scrollbar width so the layout doesn't shift when the scrollbar disappears.
function useCartScrollLock(isCartOpen) {

  useEffect(() => {
    if (isCartOpen) {
      document.body.classList.add('disable-page-scroll')

      const scrollbarWidth = getScrollbarWidth()
      if (scrollbarWidth > 0) {
        document.body.classList.add('scroll-disabled-padding')
      }
    } else {
      document.body.classList.remove('disable-page-scroll', 'scroll-disabled-padding')
    }

    return () => {
      document.body.classList.remove('disable-page-scroll', 'scroll-disabled-padding')
    }
  }, [isCartOpen])
}

export { useCartScrollLock }
